var r = /* @__PURE__ */ ((u) => (u.youtube = "youtube", u.upload = "upload", u.brightcove = "brightcove", u))(r || {});
export {
  r as Video
};
//# sourceMappingURL=propsTypes.js.map
